import { ConfirmModal } from 'components/modal/ConfirmModal';
import { Spacing, TextInput, Typography, closeModal, neutral } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { isEmpty } from 'lodash';

import { LearnersComp } from '../components/LearnersComp';
import { TrainerComp } from '../components/TrainersComp';
import {
  getLearnersInMembersColumn,
  getMembersInClassColumn,
  getTrainersInMembersColumn,
} from '../core/columns';
import { useClassesMembersController } from '../core/controller/classes-members';

export const ClassesMembersPage = () => {
  const {
    onClickAction,
    classes,
    goToLearnScorePage,
    listTrainer,
    selectedMembers,
    onChangeSelectedMembers,
    handleUpdateMembers,
    handleRemoveMember,
    disabledRemoveTrainer,
    searchTrainer,
    onChangeSearchTrainer,
    listLearner,
    searchLearner,
    onChangeSearchLearner,
    searchValue,
    onChangeSearchValue,
    handleAddGroup,
    groupInClass,
    handleAddLearnerToGroup,
    groupLearners,
    handleDeleteGroup,
    handleLoadMoreLearner,
    hasMoreLearner,
    hasMoreTrainer,
    handleLoadMoreTrainer,
  } = useClassesMembersController();

  const trainerColumns = getTrainersInMembersColumn(onClickAction, disabledRemoveTrainer);

  const learnerColumns = getLearnersInMembersColumn(
    onClickAction,
    goToLearnScorePage,
    groupLearners,
    handleAddLearnerToGroup,
  );

  const membersColumns = getMembersInClassColumn(onChangeSelectedMembers, selectedMembers);

  const showNoDataTrainer = !isEmpty(searchValue.value) && isEmpty(classes?.trainers);

  const showNoDataLearner = !isEmpty(searchValue.value) && isEmpty(classes?.learners);

  const newGroupLearners = searchValue.value
    ? groupLearners.filter((group) => group.learners.length > 0)
    : groupLearners;

  return (
    <div>
      <Spacing spacing="md" placement="bottom" type="margin">
        <TextInput
          placeholder="Search by name, phone"
          value={searchValue.value}
          onChange={onChangeSearchValue}
        />
      </Spacing>

      <div style={{ margin: '24px 0' }}>
        <TrainerComp
          trainerColumns={trainerColumns}
          trainers={classes?.trainers ?? []}
          totalTrainer={classes?.totalTrainer ?? 0}
          listTrainer={listTrainer}
          membersColumns={membersColumns}
          handleUpdateMembers={handleUpdateMembers}
          searchTrainer={searchTrainer.value}
          onChangeSearchTrainer={onChangeSearchTrainer}
          showNoDataTrainer={showNoDataTrainer}
          hasMore={hasMoreTrainer.value}
          handleLoadMoreTrainer={handleLoadMoreTrainer}
        />
      </div>

      <LearnersComp
        learnerColumns={learnerColumns}
        learners={classes?.learners ?? []}
        totalLearner={classes?.totalLearner ?? 0}
        listLearner={listLearner}
        membersColumns={membersColumns}
        handleUpdateMembers={handleUpdateMembers}
        searchLearner={searchLearner.value}
        onChangeSearchLearner={onChangeSearchLearner}
        handleAddGroup={handleAddGroup}
        groupLearners={newGroupLearners}
        handleDeleteGroup={handleDeleteGroup}
        showNoDataLearner={showNoDataLearner}
        handleLoadMoreLearner={handleLoadMoreLearner}
        hasMore={hasMoreLearner.value}
      />

      <ConfirmModal
        modalKey={MODAL_KEY.REMOVE_MEMBER}
        content={'This action can not undo.'}
        header={'Remove member'}
        onCancel={() => closeModal(MODAL_KEY.REMOVE_MEMBER)}
        onSubmit={handleRemoveMember}
        submitButton={{ label: 'Remove' }}
      />
    </div>
  );
};
